import React from "react";
import { Navigate, Route, useLocation } from "react-router-dom";

import { useProfile } from "../Hooks/UserHooks";

const AuthProtected = (props) => {
 
  const { userProfile, loading } = useProfile();
if(loading){
  return null;
}
  if (!userProfile) {
    return (
      <Navigate to={{ pathname: "/Signin" }} />
    );
  }

  return <>{props.children}</>;
};

const IsUserLoggedIn = ({ children }) => {
  const { role,loading } = useProfile();

  const location = useLocation();
if(loading){
  return null;
}
  if (location.pathname === "/logout") {
    return children;
  }

  if (
    role === "admin" ||
   role === "user" ||
  role  === "quality_manager" ||
  role === "batch_control_manager" ||
    role === "production_manager"
  ) {
    return <Navigate to="/" />;
  } else {
    return <>{children}</>;
  }
};

const AdminProtectedRoutes = (props) => {
  const { role ,loading} = useProfile();
// const userRole = localStorage.getItem("role");
 if (loading) return null;
  if ( role=== "admin") {
    return <>
    {props.children}</>;
  }
  return (
    <Navigate to={{ pathname: "/404", state: { from: props.location } }} />
  );
};
const UserProtectedRoutes = (props) => {
 const { role,loading } = useProfile();
  if (loading) return null;
 //const userRole = localStorage.getItem("role");
  if (
   role === "admin" ||
     role === "user" ||
     role === "quality_manager" ||
     role === "batch_control_manager" ||
      role === "production_manager"
  ) {
    return <>{props.children}</>;
  }
  return (
    <Navigate to={{ pathname: "/404", state: { from: props.location } }} />
  );
};
const QualityManagerProtectedRoutes = (props) => {
  const { role,loading } = useProfile();
   if (loading) return null;
 //const userRole= localStorage.getItem("role");
  if (  role === "admin" ||   role === "quality_manager") {
    return <>{props.children}</>;
  }
  return (
    <Navigate to={{ pathname: "/404", state: { from: props.location } }} />
  );
};
const BatchControlManagerProtectedRoutes = (props) => {
 const { role ,loading} = useProfile();
  if (loading) return null;
 //const userRole = localStorage.getItem("role");
  if ( role === "admin" ||   role === "batch_control_manager") {
    return <>{props.children}</>;
  }
  return (
    <Navigate to={{ pathname: "/404", state: { from: props.location } }} />
  );
};
const ProductionManagerProtectedRoutes = (props) => {
 const { role,loading } = useProfile();
  if (loading) return null;
 //const userRole = localStorage.getItem("role");
  if (  role=== "admin" ||  role=== "production_manager") {
    return <>{props.children}</>;
  }
  return (
    <Navigate to={{ pathname: "/404", state: { from: props.location } }} />
  );
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        return (
          <>
            {" "}
            <Component {...props} />{" "}
          </>
        );
      }}
    />
  );
};

export {
  AuthProtected,
  AccessRoute,
  IsUserLoggedIn,
  AdminProtectedRoutes,
  UserProtectedRoutes,
  QualityManagerProtectedRoutes,
  BatchControlManagerProtectedRoutes,
  ProductionManagerProtectedRoutes,
};
